import { isEmailValid } from "@utils/CommonUtil";

type ToolResult =
  | { status: "success"; data: { ticketNumber: string } | { delivered: true } }
  | { status: "error"; error: string };

type Dependencies = {
  sendTicket: (message: string, email?: string) => Promise<string | undefined>;
  rememberEmail: (email: string) => void;
};

export function createSupportTicketTool({ sendTicket, rememberEmail }: Dependencies) {
  return async (args?: { message?: string; email?: string }): Promise<ToolResult> => {
    try {
      const message = typeof args?.message === "string" ? args.message.trim() : "";
      if (!message) {
        return { status: "error", error: "No issue description was provided." };
      }

      const rawEmail = args?.email;
      const suppliedEmail = typeof rawEmail === "string" ? rawEmail.trim() : "";
      const emailWasGiven = rawEmail !== undefined && rawEmail !== null;
      const emailIsUsable =
        suppliedEmail === "" ? typeof rawEmail === "string" : isEmailValid(suppliedEmail);

      if (emailWasGiven && !emailIsUsable) {
        return {
          status: "error",
          error:
            "That email address is not valid. Ask the user for a corrected address and call this action again.",
        };
      }

      const email = suppliedEmail || undefined;
      const ticketNumber = await sendTicket(message, email);

      if (email) {
        rememberEmail(email);
      }

      return ticketNumber
        ? { status: "success", data: { ticketNumber } }
        : { status: "success", data: { delivered: true } };
    } catch (error) {
      console.error("Failed to create a support ticket", error);
      return {
        status: "error",
        error: "The ticket could not be created. Ask the user to try again from the Help page.",
      };
    }
  };
}
